import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import axios from '~/data/http/axios'
import helpers from '~/Classes/helpers'

import { Tooltip } from 'react-tooltip'
import Topup from '~/pages/cp/company/sms/topup'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import i18n from '~/i18n'
import NumberFunction from '~/Classes/numberFormatFunctions'
import moment from 'moment'
import SmsUpgrade from '~/pages/cp/includes/upgrade/sms'

export default function SmsSummary({
    campaign,
    template,
    subscriberCount,
    sendingLimitReached,
    messages,
    saveErrors = [],
    checkSendingLimit = () => {},
    setCanStart = () => {},
    changeStep = () => {}
}) {
    const accountMaster = useSelector((state) => state.accountMaster)
    const [contentErrors, setContentErrors] = useState([])
    const [checkingContent, setCheckingContent] = useState(true)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!campaign || !template) return
        ;(async () => {
            setCheckingContent(true)
            setCanStart(false)
            const [subjectResponse, contentResponse] = await Promise.all([
                axios.get('/campaign/checksms?content=' + campaign.subject),
                axios.get('/campaign/checksms?content=' + template.templateHTML)
            ])
            const messages = []
            if (subjectResponse.data.length) {
                messages.push(`From Name cannot contain ${subjectResponse.data.map((d) => `"${d}"`).join(' or ')}. `)
            }
            if (contentResponse.data.length) {
                messages.push(`Content cannot contain ${contentResponse.data.map((d) => `"${d}"`).join(', ')}`)
            }
            setContentErrors(messages)
            setCheckingContent(false)
        })()
    }, [campaign, template])

    const upgrade = () => {
        const theDrawer = (
            <SmsUpgrade
                onFinish={() => {
                    dispatch(siteMaster.alterSiteDrawer(false))
                    checkSendingLimit()
                }}
            />
        )
        dispatch(siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, false, '500px'))
    }

    if (checkingContent) return <LoadingIcons iconType='2' />

    const goodStuff = []
    const errors = []
    const warnings = []

    if (!subscriberCount) {
        errors.push({
            value: (
                <span>
                    <a onClick={() => changeStep(1)}>There are no valid contacts to send to</a>
                </span>
            )
        })
    }
    // else if (sendingLimitReached) {
    //     errors.push({
    //         value: <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    //             <span className="text-heavy">Credit limit reached </span>
    //             <span><a onClick={topup}>Topup</a></span>
    //         </div>
    //     })
    // }
    else {
        // const groupsAndSegments = campaign.Groups.concat(campaign.Segments).map(s => s.name).join(', ')
        // goodStuff.push({
        //     value: <span style={{display: 'flex', justifyContent: 'between'}}>
        //         <span data-tooltip-id="textSubs" data-tooltip-content={groupsAndSegments} className="cursor-pointer" onClick={() => changeStep(1)} dangerouslySetInnerHTML={{ __html: i18n.t('campaigns:standard.step3.subs', { subscriberCount: subscriberCount }) }} />
        //         <Tooltip  className={"tooltip fix-font"} id="textSubs" ></Tooltip>
        //     </span>
        // })
        // goodStuff.push({
        //     value: <div style={{display: 'flex', justifyContent: 'space-between'}}>
        //         <div dangerouslySetInnerHTML={{ __html: i18n.t('campaigns:standard.step3.subs') }} />
        //         <div>
        //         <span data-tooltip-id="textSubs" data-tooltip-content={groupsAndSegments} className="cursor-pointer" onClick={() => changeStep(1)}>{subscriberCount}</span>
        //         <Tooltip  className={"tooltip fix-font"} id="textSubs" ></Tooltip>
        //         </div>
        //     </div>
        // })
    }

    if (template.templateHTML.indexOf('{{__OPTOUT}}') === -1) {
        errors.push({
            value: (
                <span>
                    <a
                        onClick={() => changeStep(2)}
                    >{`Content must contain {{__OPTOUT}} so people can unsubscribe from your messages`}</a>
                </span>
            )
        })
    } else if (!contentErrors.length) {
        goodStuff.push({
            value: (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span className='text-heavy'>SMS Content is ok </span>
                </div>
            )
        })
    }

    const subjectChecker = helpers.smsIsValidSubject(campaign.subject)
    if (subjectChecker.messages.length) {
        subjectChecker.messages.forEach((m) =>
            errors.push({
                value: (
                    <span>
                        <a onClick={() => changeStep(2)}>{m}</a>
                    </span>
                )
            })
        )
    } else if (!contentErrors.length) {
        goodStuff.push({
            value: (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span className='text-heavy'>From Name is ok </span>
                    <span style={{ color: '#999' }}>{campaign.subject}</span>
                </div>
            )
        })
    }

    if (accountMaster.accountMaster.smsCredits >= messages * subscriberCount) {
        goodStuff.push({
            value: (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span className='text-heavy'>Credits are available </span>
                    <span style={{ color: '#999' }}>
                        {NumberFunction.formatNumber(
                            !!accountMaster.accountMaster.smsCredits ? accountMaster.accountMaster.smsCredits : 0
                        )}{' '}
                        Available
                    </span>
                </div>
            )
        })
    } else if (accountMaster?.accountMaster?.SmsAccountBillingId) {
        errors.push({
            value: (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span className='text-heavy'>
                        Insuffient SMS Credits ({accountMaster.accountMaster.smsCredits || 0} remaining)
                    </span>
                    <span>
                        <a onClick={upgrade}>Upgrade</a>
                    </span>
                </div>
            )
        })
    }

    if (contentErrors.length) {
        errors.push(...contentErrors)
    }

    const startDate = moment(campaign.startDate)
    if (startDate.hour() < 9 || startDate.hour() > 19) {
        warnings.push({
            value: (
                <span className='text-heavy'>
                    Marketing SMS messages can only be sent between 9am and 8pm in the UK so messages may be delayed
                </span>
            )
        })
    }

    setCanStart(!Boolean(errors.length))

    return (
        <Paper className='mar-b0 campaignGoodStuffHolder'>
            <Row>
                <h4 className='mar-l10 mar-b15'>Checks</h4>
                {goodStuff.length > 0 && (
                    <Column xs={12}>
                        {goodStuff.map((error, index) => {
                            var classes = 'addCampaign-checksholder'
                            return (
                                <div key={'checkOk_' + index} style={{ display: 'flex' }}>
                                    <Icons
                                        icon='tickCircle'
                                        className={classes}
                                        style={{ borderBottom: 'none' }}
                                    />
                                    <div style={{ width: '100%' }}>{error.value}</div>
                                </div>
                            )
                        })}
                    </Column>
                )}
                {(errors.length > 0 || saveErrors.length > 0) && (
                    <Column xs={12} margin={0}>
                        {errors.concat(saveErrors).map((error, index) => {
                            var classes = 'addCampaign-checksholder addCampaign-checksholder-bad'
                            return (
                                <div key={'checkErr_' + index} style={{ display: 'flex' }}>
                                    <Icons
                                        icon='crossCircle'
                                        className={classes}
                                        style={{ borderBottom: 'none' }}
                                    />
                                    <div style={{ width: '100%' }}>{error.value}</div>
                                </div>
                            )
                        })}
                    </Column>
                )}
                {warnings.length > 0 && (
                    <Column xs={12} margin={0}>
                        {warnings.map((warning, index) => {
                            var classes = 'addCampaign-checksholder addCampaign-checksholder-warn'
                            return (
                                <div key={'checkWarn_' + index} style={{ display: 'flex' }}>
                                    <Icons icon='alert' className={classes} style={{ borderBottom: 'none' }} />
                                    <div style={{ width: '100%' }}>{warning.value}</div>
                                </div>
                            )
                        })}
                    </Column>
                )}
            </Row>
        </Paper>
    )
}
